module.exports = __webpack_public_path__ + "img/Rule_box_text.3f420c11.png";